import React from 'react'

function Footer() {
    return (
        <footer className="footer mt-auto py-3 bg-white text-center">
            <div className="container">
                <span className="text-muted"> Copyright © <span id="year" /> 2025 MuradJafar.
                    Designed with by 
                        <span className="fw-medium text-primary"> MuradJafar </span>
                     All
                    rights
                    reserved
                </span>
            </div>
        </footer>
    )
}

export default Footer